import { render, staticRenderFns } from "./LoveDriftComment.vue?vue&type=template&id=542b3cc8&"
import script from "./LoveDriftComment.vue?vue&type=script&lang=js&"
export * from "./LoveDriftComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports